import { useAuthStore } from './auth-store';

/**
 * useCurrentUser — convenience hook over the auth store.
 *
 * Components usually want `user` and `signOut`, not the whole store.
 * Using a narrow hook makes re-renders cheaper (Zustand only re-renders
 * subscribers when selected fields change).
 */
export function useCurrentUser() {
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);
  return { user, signOut };
}
